<!--
  页面，主要控制页面结构和布局
-->
<template>
  <div class="lc-page">
    <!-- 头部信息 -->
    <div class="lc-page-head clearfix">
      <!-- 左侧 -->
      <div class="page-left-head">
        <slot name="header"></slot>
      </div>

      <!-- 右侧 -->
      <div class="page-right-head clearfix">
        <!-- 个人账号 -->
        <el-dropdown class="user-info-item pull-left">
          <div class="username-dropdown-link clearfix">
            <div class="lc-ellipsis-text username pull-left">{{ currentAdmin.name }}</div>
            <i class="el-icon-arrow-down el-icon--right pull-left"></i>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-postcard" @click.native="routerTo(`/admins/my/detail`)">账号信息</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" @click.native="signOut()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 消息中心 -->
        <el-popover :disabled="!can(Auth.listAlarms)" placement="left-end" width="500" trigger="click">
          <!-- 报警图标及数量 -->
          <span slot="reference">
            <el-badge :value="unresolvedAlarmCount" :max="999" class="item message-item pull-left">
              <i class="el-icon-message"></i>
            </el-badge>
          </span>

          <!-- 报警的弹窗框明细 -->
          <el-table :data="unresolvedAlarms">
            <el-table-column width="50" label="">
              <template slot-scope="scope">
                <i class="el-icon-bell" :style="`font-size: 16px; color: ${alarmColor(scope.row.level)}`"></i>
              </template>
            </el-table-column>

            <el-table-column property="title" :label="$t('navigator.columns.title')"></el-table-column>

            <el-table-column width="150" :label="$t('navigator.columns.time')">
              <template slot-scope="scope">
                {{ ts(scope.row.created_at) }}
              </template>
            </el-table-column>
          </el-table>

          <div class="m-t-10">
            <router-link :to="`/alarms/list/all`">
              <el-button size="mini" class="operate-btn"> {{ $t('navigator.btn.show_alarms') }}</el-button>
            </router-link>
          </div>
        </el-popover>
      </div>
    </div>

    <!-- 主要内容 -->
    <div v-auto-height class="lc-page-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IdentificationMixin from '@/mixins/identification'
import Auth from '@/helpers/authorizations'
import DateMixin from '@/mixins/date.js'

export default {
  mixins: [IdentificationMixin, DateMixin],
  data() {
    return {
      Auth
    }
  },
  computed: {
    /**
     * 当前管理员信息
     *
     * @returns {object} 管理员对象
     */
    currentAdmin() {
      return this.$store.state.app.currentAdmin
    },
    /**
     * 未读告警的数量
     *
     * @returns {number} 数量
     */
    unresolvedAlarmCount() {
      return this.$store.state.app.unresolvedAlarmCount
    },
    /**
     * 未读告警信息
     * 有数量限制，只显示前N条
     *
     * @returns {Array<object>} 告警
     */
    unresolvedAlarms() {
      return this.$store.state.app.unresolvedAlarms
    }
  },
  methods: {
    /**
     * 报警的颜色
     *
     * @param {string} level 报警级别。info/warning/error
     * @returns {string} 颜色
     */
    alarmColor(level) {
      switch (level) {
        case 'warning':
          return '#E6A23C'
        case 'error':
          return '#F56C6C'
        default:
          return '#909399'
      }
    },
    /**
     * 登出
     */
    signOut() {
      this.$http.delete('/backend/admins/access_token').then(() => {
        location.href = '/auth.html#/login?service_provider_code=' + this.currentServiceProvider.code
        localStorage.removeItem('is_login')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-page {
  padding: 7px; // .main-page-right 有 8px，共15px
  font-size: 14px;
  margin-bottom: 50px; // 预留分页栏遮挡部分
}
.lc-page-head {
  display: flex;
  margin-bottom: 10px;

  .page-left-head {
    flex: 1 0 auto;

    .el-button-group {
      &.pull-right {
        display: flex; // 修复标题栏按钮组某些icon（lc-ico-*）会导致按钮高度无法对齐的问题
      }
    }
  }

  .page-right-head {
    width: 180px;
    flex: 0 0 auto;
    padding-left: 15px;
  }

  .user-info-item {
    background-color: #fff;
    line-height: 32px;
    height: 32px;
    border-radius: 4px;
    margin-right: 15px;
    padding: 0px 10px;

    .username-dropdown-link {
      .username {
        width: 70px;
        text-align: center;
        line-height: 30px;
        overflow-x: hidden;
        display: inline-block;
        white-space: nowrap;
      }

      i {
        margin-top: 8px;
      }
    }
  }

  .message-item {
    margin-top: 5px;
    cursor: pointer;

    i {
      font-size: 20px;
    }
  }
}
</style>
